/**
 * @module RemoteDataCache
 * @memberof web-panel.cache
 * @author Pavel Shabardin (<bigbn@mail.ru>) Thursday, 19th November 2020 8:40:19 am
 * @copyright 2015 - 2020 SKAT LLC, Delive LLC
 * @flow
 */
import { Injectable } from '../serviceLocator'
import worker from './cache.async-worker'

@Injectable('remoteDataCache', true)
class RemoteDataCache {
  marks: { [string]: string }
  worker: {pull: (endpoint: string, cacheMark: string, marks: {}) => {}}

  constructor () {
    this.marks = global.CACHE_MARKS
    this.worker = worker()
  }

  async pull (endpoint: string, cacheMark: string) : Promise<any> {
    return await this.worker.pull(endpoint, cacheMark, this.marks)
  }
}

export default RemoteDataCache
